<template>
  <div class="detail-page">
    <div class="detail-filter">
      <div class="filter-fields">
        <div class="filter-field">
          <el-select v-model="queryData.trainType" placeholder="训练类型" size="small">
            <el-option label="全部" value="0"></el-option>
            <el-option label="随心" value="1"></el-option>
            <el-option label="动作" value="2"></el-option>
            <el-option label="系统课程" value="3"></el-option>
            <el-option label="训练计划日程" value="4"></el-option>
          </el-select>
        </div>
        <div class="filter-field">
          <el-input v-model="queryData.completePercent" placeholder="完成度" clearable size="small"></el-input>
        </div>
        <div class="filter-field">
          <el-input v-model="queryData.completeIndicators" placeholder="完成指标" clearable size="small"></el-input>
        </div>
      </div>
      <div class="filter-actions">
        <el-button type="primary" size="small" icon="el-icon-search" @click="clickQuery">查询</el-button>
        <el-button type="primary" size="small" plain icon="el-icon-refresh-left" @click="clickQueryReset">重置</el-button>
      </div>
    </div>

    <!-- 列表 -->
    <div class="table-section">
      <div class="table-container" ref="tableContainer">
        <el-table
          :data="dataList"
          class="detail-table"
          :height="tableHeight"
          :header-cell-style="tableHeaderStyle"
          :cell-style="tableCellStyle"
          @sort-change="handleSortChange">
          <el-table-column prop="trainType" label="训练类型" min-width="120" sortable="custom" show-overflow-tooltip>
            <template slot-scope="props">
              <span v-if="props.row.trainType == 1">随心练</span>
              <span v-if="props.row.trainType == 2">动作库</span>
              <span v-if="props.row.trainType == 3">系统课程</span>
              <span v-if="props.row.trainType == 4">训练计划日程</span>
            </template>
          </el-table-column>
          <el-table-column prop="actionId" label="动作编号" min-width="120" sortable="custom" show-overflow-tooltip></el-table-column>
          <el-table-column prop="courseId" label="课程编号" min-width="120" sortable="custom" show-overflow-tooltip></el-table-column>
          <el-table-column prop="planMyDayId" label="训练日程编号" min-width="140" sortable="custom" show-overflow-tooltip></el-table-column>
          <el-table-column prop="completePercent" label="完成度" min-width="100" sortable="custom" show-overflow-tooltip>
            <template slot-scope="props">
              {{props.row.completePercent}}%
            </template>
          </el-table-column>
          <el-table-column prop="completeIndicators" label="完成指标" min-width="110" sortable="custom" show-overflow-tooltip>
            <template slot-scope="props">
              {{props.row.completeIndicators}}个
            </template>
          </el-table-column>
          <el-table-column prop="trainTime" label="训练时长" min-width="120" sortable="custom" show-overflow-tooltip>
            <template slot-scope="props">
              {{props.row.trainTime}}秒
            </template>
          </el-table-column>
          <el-table-column prop="weight" label="重量" min-width="100" sortable="custom" show-overflow-tooltip></el-table-column>
          <el-table-column prop="outputPower" label="输出功率" min-width="140" sortable="custom" show-overflow-tooltip></el-table-column>
          <el-table-column prop="calories" label="卡路里" min-width="140" sortable="custom" show-overflow-tooltip></el-table-column>
          <el-table-column prop="numLeft" label="拉动次数" min-width="180" sortable="custom" show-overflow-tooltip>
            <template slot-scope="props">
              L:{{props.row.numLeft}};R:{{props.row.numRight}};总:{{props.row.numTotal}}
            </template>
          </el-table-column>
          <el-table-column prop="numGroup" label="训练组数" min-width="110" sortable="custom" show-overflow-tooltip></el-table-column>
          <el-table-column prop="numDetailLeft1" label="明细完成次数L" min-width="140" sortable="custom" show-overflow-tooltip>
            <template slot-scope="props">
              {{props.row.numDetailLeft1}}/{{props.row.numDetailLeft2}}
            </template>
          </el-table-column>
          <el-table-column prop="numDetailRight1" label="明细完成次数R" min-width="140" sortable="custom" show-overflow-tooltip>
            <template slot-scope="props">
              {{props.row.numDetailRight1}}/{{props.row.numDetailRight2}}
            </template>
          </el-table-column>
          <el-table-column prop="weightLeft" label="明细容量L" min-width="120" sortable="custom" show-overflow-tooltip></el-table-column>
          <el-table-column prop="weightRight" label="明细容量R" min-width="120" sortable="custom" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="180" sortable="custom" show-overflow-tooltip></el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 分页 -->
    <div class="pagination-wrapper">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page_no"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="page_size"
        layout="total, prev, pager, next, sizes, jumper"
        :total="dataListnum">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      queryData: {
        trainType: '0',
        completePercent: '',
        completeIndicators: '',
        terminalUserId: ''
      },
      dataList: [],
      dataListnum: 0,
      tableHeight: 480,
      page_no: 1,
      page_size: 5,
      sortField: '',
      sortOrder: ''
    }
  },
  mounted () {
    this.$nextTick(this.initTableResizeObserver)
  },
  beforeDestroy () {
    this.destroyTableResizeObserver()
  },
  methods: {
    tableHeaderStyle () {
      return { textAlign: 'center', background: 'var(--aptus-surface-muted, #F5F6F8)', color: 'var(--aptus-text-secondary, #5E6670)', fontWeight: '600' }
    },
    tableCellStyle () {
      return { textAlign: 'center' }
    },
    calcTableHeight () {
      var that = this
      this.$nextTick(function () {
        var container = that.$refs.tableContainer
        if (!container) return
        var height = container.clientHeight
        if (height > 0) {
          that.tableHeight = Math.max(240, Math.floor(height))
        }
      })
    },
    initTableResizeObserver () {
      var that = this
      this.calcTableHeight()
      if (typeof ResizeObserver === 'undefined') return
      this.tableResizeObserver = new ResizeObserver(function () {
        that.calcTableHeight()
      })
      if (this.$refs.tableContainer) {
        this.tableResizeObserver.observe(this.$refs.tableContainer)
      }
    },
    destroyTableResizeObserver () {
      if (this.tableResizeObserver) {
        this.tableResizeObserver.disconnect()
        this.tableResizeObserver = null
      }
    },
    LoadData (row) {
      this.queryData.terminalUserId = row.id
      this.TrainReportList()
      this.TrainReportNum()
    },
    handleSortChange ({ prop, order }) {
      this.sortField = prop || ''
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.page_no = 1
      this.TrainReportList()
      this.TrainReportNum()
    },
    handleSizeChange (val) {
      this.page_size = val
      this.TrainReportList()
      this.TrainReportNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.TrainReportList()
      this.TrainReportNum()
    },
    clickQuery () {
      this.page_no = 1
      this.TrainReportList()
      this.TrainReportNum()
    },
    clickQueryReset () {
      this.queryData.trainType = '0'
      this.queryData.completePercent = ''
      this.queryData.completeIndicators = ''
      this.clickQuery()
    },
    TrainReportList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.trainType = that.queryData.trainType
      data.completePercent = that.queryData.completePercent
      data.completeIndicators = that.queryData.completeIndicators
      data.terminalUserId = that.queryData.terminalUserId
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sortField = that.sortField
      data.sortOrder = that.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TrainReportList, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataList = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    TrainReportNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.trainType = that.queryData.trainType
      data.completePercent = that.queryData.completePercent
      data.completeIndicators = that.queryData.completeIndicators
      data.terminalUserId = that.queryData.terminalUserId
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_TrainReportNum, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.detail-page {
  padding: 20px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

/* 筛选栏 */
.detail-filter {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  padding: 10px 14px;
  background: #FFFFFF;
  border: 1px solid #E2E6EC;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(15, 26, 46, 0.04);
  margin-bottom: 12px;
  flex-shrink: 0;
}

.filter-fields {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
  flex: 1;
  min-width: 0;
}

.filter-field {
  min-width: 0;

  /deep/ .el-input,
  /deep/ .el-select {
    width: 160px;
  }
}

.filter-actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;

  /deep/ .el-button {
    margin-left: 0;
  }
}

/* 表格区域 */
.table-section {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.table-container {
  position: relative;
  flex: 1;
  min-height: 0;
  width: 100%;
  background: #FFFFFF;
  border-radius: 8px;
  border: 1px solid #E2E6EC;
  overflow: hidden;
}

.detail-table {
  /deep/ .el-table__body td {
    padding: 10px 0;
    background: #FFFFFF;
    border-bottom: 1px solid #EFF1F5;
  }

  /deep/ .el-table__body tr:hover > td {
    background: #EFF6FF !important;
  }

  /deep/ .el-table__header th {
    padding: 10px 0;
    background: #F5F6F8 !important;
    border-bottom: 1px solid #E2E6EC;
    color: #5E6670;
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  /deep/ .el-table__header th .cell {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    word-break: keep-all;
    line-height: 20px;
    padding: 0 8px;
  }

  /deep/ .el-table__header th .caret-wrapper {
    flex-shrink: 0;
    margin-left: 4px;
  }

  /deep/ thead tr th {
    border-radius: 0 !important;
  }
}

/* 分页 */
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #E2E6EC;
}

/* 按钮主题覆盖 */
/deep/ .el-button--primary {
  color: #FFF;
  background-color: #2563EB;
  border-color: #2563EB;
  font-weight: 500;
  border-radius: 6px;

  &:hover {
    background-color: #3B82F6;
    border-color: #3B82F6;
    box-shadow: 0 2px 8px rgba(21, 101, 192, 0.25);
  }
}

/deep/ .el-button--primary.is-plain {
  color: #2563EB;
  background: #EFF6FF;
  border-color: #A8D0F5;

  &:hover {
    background: #2563EB;
    color: #FFF;
    border-color: #2563EB;
  }
}
</style>
